<template>
  <div>
    <div class="header-actions">
      <div class="icon-print" v-print="'#printTable'">
        <i title="Imprimir" class="fas fa-print"></i>
      </div>

      <div class="div-total-records text-center">
        Total <b>{{ totalRecords }} </b>
        <span v-if="totalRecords > 1">registros</span>
        <span v-else>registro</span>
      </div>
    </div>

    <table id="printTable" class="table table-responsive-xs">
      <thead>
        <tr>
          <th class="td-checkbox" v-if="showChecks">
            <div class="hide-print">
              <b-form-checkbox v-model="selectAll" @change="select" />
            </div>
          </th>
          <th v-for="(obj, ind) in header" :key="ind">
            <div class="title-margem" :class="obj.classCssTitle">
              <i class="fas fa-search" v-if="obj.iconSearch"></i>
              <span class="title-header"> {{ obj.title }}</span>
            </div>
          </th>
        </tr>
      </thead>
      <draggable v-model="data" tag="tbody" @change="checkMove" :options="{ disabled: !dragAndDrop }">
        <tr v-for="(row, index) in data" :key="index" :style="row.rowCss">
          <td class="td-checkbox" v-if="showChecks">
            <div class="hide-print" :class="{ 'center-vertical': row.photo != null }">
              <b-form-checkbox v-model="selected" :value="row.id" />
            </div>
          </td>
          <td v-for="(obj, ind) in header" :key="ind" :class="{ 'drag-and-drop': dragAndDrop }">
            <TableItem :obj="obj" :row="row" />
          </td>
        </tr>
      </draggable>
      <tbody v-show="data.length == 0">
        <tr>
          <td colspan="12">
            <span>Nenhum registro encontrado!</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import TableItem from "./TableItem.vue";
import print from "vue-print-nb";

import draggable from "vuedraggable";

import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {
  components: { draggable, TableItem },
  directives: {
    print,
  },
  props: {
    header: Array,
    data: Array,
    totalRecords: Number,
    showChecks: {
      type: Boolean,
      default: true,
    },
    dragAndDrop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectAll: false,
      dataDragging: [],
    };
  },
  computed: {
    ...mapState("generic", ["selected"]),
    ...mapGetters("generic", ["event"]),
    selected: {
      get() {
        return this.$store.state.generic.selected;
      },
      set(value) {
        this.addSelected(value);
      },
    },
  },
  methods: {
    ...mapMutations("generic", ["addSelected", "addEvent"]),
    ...mapActions("generic", ["pdfApi"]),
    select() {
      this.addSelected([]);
      if (this.selectAll) {
        for (let i in this.data) {
          this.selected.push(this.data[i].id);
        }
      }
    },
    checkMove() {
      if (this.dragAndDrop) {
        var listIds = [];
        this.data.forEach((item) => {
          listIds.push(item.id);
        });

        this.addEvent({
          name: "tableDragAndDrop",
          data: { listIds: listIds },
        });
      }
    },
  },
  beforeDestroy() {
    this.addSelected([]);
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "deselectAll") {
          this.selectAll = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
table tbody tr td {
  max-width: 350px;
}

.table th,
.table td {
  height: 10px !important;
  padding-left: 5px !important;
  padding-top: 7px !important;
  padding-bottom: 5px !important;
  padding-right: 5px !important;
  border-bottom: 0px !important;
}

.td-checkbox {
  width: 0px;
}

tr:hover {
  background-color: #fafafc;
}

.title-header {
  font-size: 13px;
  color: #757d8c;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px !important;
}

.table-number {
  font-size: 14px;
  font-weight: bold;
}

.table-main {
  color: #757d8c;
  max-width: 200px;
}

.drag-and-drop {
  cursor: move;
}

.icon-print {
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 5px;
  width: 100px;
}

.title-table-print {
  font-size: 13.8px;
  margin-left: 6px;
}

.table thead th {
  vertical-align: middle !important;
}

.td-checkbox {
  width: 30px;
  vertical-align: middle !important;
}

.td-checkbox .hide-print {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.td-checkbox .custom-control {
  margin: 0;
}

.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.div-total-records {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e6e7eb;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  min-width: 150px;
  margin-bottom: 10px;
}
</style>
